
        var i18n = require('cadenza/utils/i18n/i18n');
        module.exports = (function () {
          var messages = {"de":{"liveMode.paused.info":"Der Live-Modus wurde gestoppt.","lastUpdateTime.label":"Letzte Datenaktualisierung"},"en":{"liveMode.paused.info":"Live mode was stopped.","lastUpdateTime.label":"Last data refresh"}};
          return function () {
            return i18n.loaderI18n.apply(messages[window.Disy.language], arguments);
          };
        })();